<script setup lang="ts">
import { useToast } from '@/hooks/useToast'
import { MessageSquare, Phone, User } from 'lucide-vue-next'

const { showWarning } = useToast()

const props = defineProps<{
  module: string
  name: string
  phone: string
  workNumber: number
}>()

const handleChat = () => {
  if (!props.workNumber) {
    showWarning('该用户未获取到工号, 无法发起狐聊!')
    return
  }
  window.hxe.showChat({
    group: false,
    target: String(props.workNumber),
    success() {},
    fail() {
      window.hxe.showToast({
        content: '不好意思, 拉起狐聊失败!'
      })
    }
  })
}

const handleCall = () => {
  window.hxe.callPhone({
    number: props.phone,
    success() {},
    fail() {
      window.hxe.showToast({
        content: '不好意思, 拨打电话失败!'
      })
    }
  })
}
</script>

<template>
  <div
    class="flex justify-between items-center py-4 border-b border-gray-50 last:border-b-0 hover:bg-gray-50/30 transition-all duration-200 group"
  >
    <div class="flex items-center space-x-3">
      <span v-if="module" class="font-semibold text-sm text-gray-600 w-12">{{
        module
      }}</span>
      <div class="flex items-center space-x-3">
        <div
          class="w-9 h-9 bg-gradient-to-br from-blue-50 to-indigo-100 rounded-full flex items-center justify-center ring-2 ring-white shadow-sm group-hover:shadow-md transition-all duration-200"
        >
          <User class="w-4 h-4 text-blue-600" />
        </div>
        <span
          class="text-sm text-gray-800 font-medium group-hover:text-gray-900 transition-colors"
          >{{ name || '--' }}</span
        >
      </div>
    </div>
    <div class="flex items-center space-x-2">
      <button
        @click="handleChat"
        class="flex items-center justify-center w-10 h-10 text-blue-500 hover:text-blue-600 hover:bg-blue-50 rounded-full transition-all duration-200 group/btn"
      >
        <MessageSquare
          class="w-5 h-5 group-hover/btn:scale-110 transition-transform"
        />
      </button>
      <button
        @click="handleCall"
        class="flex items-center justify-center w-10 h-10 text-green-500 hover:text-green-600 hover:bg-green-50 rounded-full transition-all duration-200 group/btn"
      >
        <Phone class="w-5 h-5 group-hover/btn:scale-110 transition-transform" />
      </button>
    </div>
  </div>
</template>
